import { useParams } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'

import { mapLeadDetailResponse } from 'store/lead'
import { mapGetLeadContactsResponse } from 'queries/lead-contact'
import { mapLeadAddress } from 'store/lead'
import { getDetailApi } from 'services/lead-detail'
import useAppQuery, { AppQueryOptions } from 'hooks/use-app-query'
import { leadKey, leadContactKey, leadAddressKey } from 'utils/constants/queryKey'
import { useInvalidateLeadTabV2 } from 'queries/lead-tab-v2'

interface Props {
  leadId?: string
  queryOptions?: AppQueryOptions
}

const useLeadData = (props?: Props) => {
  const { leadId: leadIdParam = '' } = useParams<{ leadId: string }>()
  const leadId = props?.leadId ?? leadIdParam
  const invalidateV2LeadTabCount = useInvalidateLeadTabV2(leadId)
  const queryClient = useQueryClient()
  const queryResult = useAppQuery(leadKey.data(leadId), () => getDetailApi({ lead_id: leadId }), {
    ...props?.queryOptions,
    enabled: !!leadId && (props?.queryOptions?.enabled ?? false),
    onSuccess: (data) => {
      queryClient.setQueryData(leadKey.detail(leadId), mapLeadDetailResponse(data.lead_detail))
      invalidateV2LeadTabCount()
      queryClient.setQueryData(leadContactKey.list({ lead_id: leadId }), mapGetLeadContactsResponse(data.lead_contacts))
      queryClient.setQueryData(leadAddressKey.list(leadId), mapLeadAddress(data.lead_addresses))
    },
  })

  return queryResult
}

const useInvalidateLeadData = (leadId: string) => {
  const queryClient = useQueryClient()
  return () => queryClient.invalidateQueries(leadKey.data(leadId))
}

export { useInvalidateLeadData }

export default useLeadData
